import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Truck, ClipboardList, FileText, Users, Package, CheckCircle2 } from "lucide-react";
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Tooltip, Cell } from "recharts";

const CAT_LABELS = { excavadora: "Excavadora", cargador: "Cargador", camion_minero: "C. Minero", retroexcavadora: "Retro", grua: "Grúa", compactadora: "Compact.", otro: "Otro" };

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/admin/stats").then((r) => setStats(r.data)); }, []);
  if (!stats) return <div className="text-muted-foreground">Cargando...</div>;

  const cards = [
    { label: "Maquinaria total", value: stats.total_machinery, icon: Truck },
    { label: "Disponibles", value: stats.available, icon: Package },
    { label: "Cotizaciones", value: stats.total_quotes, sub: `${stats.pending_quotes} pendientes`, icon: ClipboardList },
    { label: "Contratos", value: stats.total_contracts, sub: `${stats.active_contracts} activos`, icon: FileText },
    { label: "Usuarios", value: stats.total_users, icon: Users },
    { label: "Contratos activos", value: stats.active_contracts, icon: CheckCircle2 },
  ];

  const chartData = stats.by_category.map((c) => ({ name: CAT_LABELS[c.category] || c.category, count: c.count }));

  return (
    <div>
      <h1 className="font-display font-black text-3xl tracking-tight mb-6">RESUMEN GENERAL</h1>
      <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 mb-8" data-testid="admin-stats">
        {cards.map(({ label, value, sub, icon: Icon }) => (
          <div key={label} className="border border-border p-5 hover:border-brand transition-colors">
            <div className="flex items-center justify-between mb-3">
              <span className="overline text-muted-foreground">{label}</span>
              <Icon size={18} className="text-brand" />
            </div>
            <div className="font-display font-black text-4xl tracking-tight">{value}</div>
            {sub && <div className="text-xs text-muted-foreground mt-1">{sub}</div>}
          </div>
        ))}
      </div>

      <div className="border border-border p-6">
        <h2 className="font-display font-bold text-xl tracking-tight mb-6">MAQUINARIA POR CATEGORÍA</h2>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={chartData}>
            <XAxis dataKey="name" tick={{ fontSize: 12 }} stroke="hsl(var(--muted-foreground))" />
            <YAxis allowDecimals={false} stroke="hsl(var(--muted-foreground))" />
            <Tooltip cursor={{ fill: "hsl(var(--muted))" }} contentStyle={{ background: "hsl(var(--card))", border: "1px solid hsl(var(--border))" }} />
            <Bar dataKey="count" radius={[2, 2, 0, 0]}>
              {chartData.map((_, i) => <Cell key={i} fill="#FFCC00" />)}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
